enum ActionTypes {
	request = 'GroupProductHistory.request',
	receive = 'GroupProductHistory.receive',
	prune = 'GroupProductHistory.prune',
}

export default ActionTypes;
